export default function pressaoParaTemperatura(num) {
    let resultPress;

    if (num < 3.3) {
        resultPress = (
            (-3.35881870 * 10) +
            (2.01707611 * 10 * num) +
            (-8.34423935 * Math.pow(num, 2)) +
            (3.79038331 * Math.pow(num, 3)) +
            (-1.02796428 * Math.pow(num, 4)) +
            (1.11461918 * Math.pow(num, 5) * 0.1)
        );
    } else {
        resultPress = (
            (-3.34880221 * 10) +
            (1.84422839 * 10 * num) +
            (-4.33582234 * Math.pow(num, 2)) +
            (7.72762604 * Math.pow(10, -1) * Math.pow(num, 3)) +
            (-7.88645855 * Math.pow(10, -2) * Math.pow(num, 4)) +
            (4.11460412 * Math.pow(10, -3) * Math.pow(num, 5)) +
            (-8.49621355 * Math.pow(10, -5) * Math.pow(num, 6))
        );
    }

    return resultPress;
}